import { dashboard } from 'types';
import { handlePasscodeErrorsInModal } from 'utils/passcodeUtils';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { RebalanceRequest } = protos;

export function forceRebalance(request: dashboard.RebalanceRequest, passcode?: string): ApiAction {
  return {
    TockApi: {
      postProto: '/rebalance',
      request: RebalanceRequest.fromObject(request),
      type: AppConstants.REBALANCING_FORCE,
      toast: 'Rebalancing applied',
      requestScope: {
        passcode,
      },
      onError: {
        ...handlePasscodeErrorsInModal,
        defaultToOriginal: true,
      },
    },
  };
}
